export default {
  currency: 'EUR',
};
